  import  firebase from 'firebase/app';
  import 'firebase/storage';
  import 'firebase/firestore';
  import 'firebase/analytics'

 // Your web app's Firebase configuration
  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  var firebaseConfig = {
    apiKey: "AIzaSyBY4T6e0zGr75F-SKvrLZwL3hm0GD4KMkA",
    authDomain: "firegram-5a593.firebaseapp.com",
    projectId: "firegram-5a593",
    storageBucket: "firegram-5a593.appspot.com",
    messagingSenderId: "11743176367",
    appId: "1:11743176367:web:3e39a75393f2d60f5b165a",
    measurementId: "G-SDLH5L19RM"
  };
  // Initialize Firebase
  firebase.initializeApp(firebaseConfig);
  firebase.analytics();

  const projectStorage = firebase.storage();
  const projectFirestore = firebase.firestore();
  const timestamp = firebase.firestore.FieldValue.serverTimestamp;

  export { projectFirestore, projectStorage, timestamp};
